module.exports = __webpack_public_path__ + "img/weixincode.70044b6f.jpg";